export { default as SimplePlayer } from "./player.js";
export { default as Plugin } from "./plugin/plugin.js";
export { default as BasePlugin } from "./plugin/basePlugin.js";
import * as events from "./events.js";
export { events as Events };
export { default as STATE_CLASS } from "./stateClassMap.js";
export { default as I18N } from "./lang/i18n.js";
export { default as Errors } from "./error.js";
export { default as Sniffer } from "./utils/sniffer.js";
export { default as Util } from "./utils/util.js";
export { default } from "./index.umd.js";
export { STATES } from "./state.js";
export { default as DefaultPresetEn } from "./presets/default-en.js";
export { default as DefaultPreset } from "./presets/default.js";
export { default as LivePreset } from "./presets/live.js";
export { default as MobilePreset } from "./presets/mobile.js";
export { default as langZhHk } from "./lang/zh-hk.js";
export { default as langJp } from "./lang/jp.js";
export { default as langZhCn } from "./lang/zh-cn.js";
export { default as Danmu } from "./plugins/danmu/index.js";
export { default as TextTrack } from "./plugins/track/index.js";
export { default as DanmuIcon } from "./plugins/danmu/danmuIcon.js";
export { default as DanmuPanel } from "./plugins/danmu/danmuPanel.js";



//////////////////
// WEBPACK FOOTER
// ./node_modules/_xgplayer@3.0.5@xgplayer/es/index.js
// module id = null
// module chunks = 